<template>
<div class="civii-messages-container">
  <div v-for="(message, index) in _messages" :key="'normal' + index"
    :class="['civii-message', (side == null) ? 'left' : side]">
    <div class="civii-message-content">
      <content-render :content="message.text"/>
      <action-buttons v-if="message.hasOwnProperty('buttons') && message.buttons.length > 0"
        :buttons="message.buttons"
      />
    </div>
  </div>
</div>
</template>

<script>
import ContentRender from '../../widgets/ContentRender/ContentRender.js'
import ActionButtons from '../../widgets/ActionButtons/ActionButtons.vue'

export default {
  props: {
    messages: [Array, String, Object],
    side: String
  },
  computed: {
    _messages () {
      let messages = JSON.parse(JSON.stringify(this.messages))
      if (typeof messages === 'string') {
        messages = {text: messages}
      }
      if (typeof messages === 'object' && messages.text != null) {
        messages = [messages]
      }
      return messages
    }
  },
  components: {
    'action-buttons': ActionButtons,
    'content-render': ContentRender
  }
}
</script>



// WEBPACK FOOTER //
// src/components/answers/Normal/Normal.vue